import { Suspense } from "react";
import { TopBarProgressbar } from "@components/topProgressbar";
import { Helmet } from "react-helmet";
import { appRoutesConfig, appGlobalRoutes } from "@pages/appRoutesConfig";
import { pageRoutes } from "@pages/routes";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import { useAppSelector } from "@redux";
import Error403 from "@pages/error/error403";
import Error404 from "@pages/error/error404";

export const AppRouter = () => {
  const { actions } = useAppSelector((S) => S.Permission);

  return (
    <Suspense fallback={<TopBarProgressbar />}>
      <BrowserRouter>
        <Routes>
          {appRoutesConfig.map((L) => {
            const hasLayoutAccess = L.auth.every((P) => actions.includes(P));
            if (hasLayoutAccess)
              return L.routes.map((R) => {
                const hasPageAccess = R.auth.every((P) => actions.includes(P));
                if (hasPageAccess)
                  return (
                    <Route
                      path={R.path}
                      key={R.path + R.title}
                      element={
                        <L.layout>
                          <Helmet>
                            {R?.description && (
                              <meta
                                name="description"
                                content={R.description}
                              />
                            )}
                            {R?.title && <title>{"Negah | " + R.title}</title>}
                          </Helmet>
                          <R.component />
                        </L.layout>
                      }
                    ></Route>
                  );
                else
                  return (
                    <Route path="/*" index={false} element={<Error403 />} />
                  );
              });
            else
              return <Route path="/*" index={false} element={<Error403 />} />;
          })}
          {appGlobalRoutes.map((G) => (
            <Route
              path={G.path}
              key={G.path + G.title}
              element={
                G.layout ? (
                  <G.layout>
                    <Helmet>
                      {G?.description && (
                        <meta name="description" content={G.description} />
                      )}
                      {G?.title && <title>{G.title}</title>}
                    </Helmet>
                    <G.component />
                  </G.layout>
                ) : (
                  <>
                    <Helmet>
                      {G?.description && (
                        <meta name="description" content={G.description} />
                      )}
                      {G?.title && <title>{G.title}</title>}
                    </Helmet>
                    <G.component />
                  </>
                )
              }
            />
          ))}
          <Route
            path="/"
            element={<Navigate to={pageRoutes.START_PAGE} replace />}
          />
          <Route path="/*" index={false} element={<Error404 />} />;
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
};
